import React from 'react'
import { useToast } from '@/molecules/Toast'
import { useLegacyEffect } from '@/molecules/utils'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchHeroSection } from './TorchHeroSection'
import { TorchWatchSection } from './TorchWatchSection'
import { WhyAngelSection } from './WhyAngelSection'

export const SubmitView: React.FC = () => {
  const { showToast } = useToast()
  const { t } = useTranslate('create')
  const { query } = useSafeRouter()

  useLegacyEffect(() => {
    if (query?.inquired) {
      showToast(t('thankYouForReachingOut', "Thank you for reaching out! We'll be in touch with you soon."), {
        canRepeatToasts: false,
        showInMillis: 5000,
        className: 'bg-oxide-100 border-oxide-300 !text-black',
        shouldHideClose: true,
      })
    }
  }, [query, showToast, t])

  return (
    <main className="bg-core-gray-950 pt-16 lg:pt-20">
      <TorchHeroSection />
      <TorchWatchSection />
      <WhyAngelSection />
    </main>
  )
}
